import React from 'react';
import { makeLinkInfoInPopover } from '../make-link-info-in-popover';
import { LinksViewModel } from '../links.viewmodel';
import { ILinkDTO } from '../../../../../../../api/meetings.dao';
import { LinkItemLabel } from '../../../../shared/link-info/link-item-label';
import { LinkItemButtons } from '../../../../shared/link-info/link-item-buttons';
import { MeetingTemplateLink } from '../../../../../../../api/blueprints/meeting.template.types';

type Props = {
    className?: string;
    onDelete?: () => void;
    vm?: LinksViewModel;
    isMeetingLink: boolean;
} & (ILinkDTO | MeetingTemplateLink);

type LabelProps = Props & { isOpen: boolean };

const LabelWithPopover = makeLinkInfoInPopover<LabelProps>(LinkItemLabel);

export const LinkItem = (props: Props) => {
    return (
        <div className={`event_form__items-section__item-wrapper event-link__item ${props.className}`}>
            <LabelWithPopover {...props}/>
            <LinkItemButtons url={props.url} />
        </div>
    );
};
